import React from "react";
import {motion} from "framer-motion";

type RevealProps = {
    children: React.ReactNode
    /** Stagger helper — multiplied by 60ms. */
    index?: number
    delay?: number
    y?: number
    className?: string
    style?: React.CSSProperties
    as?: 'div' | 'section' | 'li' | 'article'
}

/**
 * Fades content up the first time it enters the viewport. Kept deliberately
 * subtle so the site still feels fast rather than animated.
 */
const Reveal = (
    {
        children,
        index = 0,
        delay = 0,
        y = 24,
        className,
        style,
        as = 'div'
    }: RevealProps) => {

    const MotionTag = motion[as] as any

    return (
        <MotionTag
            className={className}
            style={style}
            initial={{opacity: 0, y}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true, margin: '-60px'}}
            transition={{
                duration: 0.6,
                delay: delay + index * 0.06,
                ease: [0.16, 1, 0.3, 1]
            }}
        >
            {children}
        </MotionTag>
    )
}

export default Reveal
